import { AsyncPipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'sh-auth-error-page',
  template: `<pre>{{ error$ | async | json }}</pre>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    JsonPipe
  ]
})
export class ErrorPageComponent {
  readonly #authService = inject(AuthService);

  error$: Observable<Error> = this.#authService.error$;
}
